import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { CheckCircle, XCircle, ArrowLeft } from "lucide-react";

function OdemeSonuc() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const success = searchParams.get("success") === "true";
  const amount = searchParams.get("amount");
  const currency = searchParams.get("currency");
  const installment = searchParams.get("installment");
  const xid = searchParams.get("xid");
  const authCode = searchParams.get("authCode");
  const respText = searchParams.get("respText");
  const respCode = searchParams.get("respCode");
  const error = searchParams.get("error");

  useEffect(() => {
    setLoading(false);
  }, []);

  if (loading) {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light">
        <div
          className="spinner-border text-primary"
          role="status"
          style={{ width: "3rem", height: "3rem" }}
        >
          <span className="visually-hidden">Yükleniyor...</span>
        </div>
      </div>
    );
  }

  return (
    <div
      className="min-vh-100 d-flex align-items-center justify-content-center px-2 px-sm-3 px-md-4 py-3 py-md-4"
      style={{
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      }}
    >
      <div className="container-fluid container-sm container-md container-lg">
        <div className="row justify-content-center">
          <div className="col-12 col-sm-11 col-md-10 col-lg-8 col-xl-6">
            <div className="card shadow-lg border-0 rounded-3 rounded-md-4 animate__animated animate__fadeInUp">
              <div className="card-body p-3 p-sm-4 p-md-5">
                {success ? (
                  <>
                    <div className="text-center mb-3 mb-md-4">
                      <div className="mb-3 mb-md-4 animate__animated animate__bounceIn">
                        <CheckCircle
                          size={window.innerWidth < 576 ? 60 : 80}
                          className="text-success"
                        />
                      </div>
                      <h1 className="display-6 display-md-5 fw-bold text-success mb-2 mb-md-3">
                        Ödeme Başarılı!
                      </h1>
                      <p className="fs-6 fs-md-5 text-muted mb-0 px-2">
                        <i className="bi bi-shield-check me-1 me-md-2"></i>
                        İşleminiz güvenli bir şekilde tamamlandı
                      </p>
                    </div>

                    <div
                      className="alert alert-success border-0 shadow-sm mb-3 mb-md-4 py-2 py-md-3"
                      role="alert"
                    >
                      <i className="bi bi-check-circle-fill me-2"></i>
                      <span className="d-none d-sm-inline">
                        Ödemeniz başarıyla alınmıştır. Teşekkür ederiz!
                      </span>
                      <span className="d-inline d-sm-none">
                        Ödeme başarılı. Teşekkürler!
                      </span>
                    </div>

                    <div className="bg-light rounded-3 p-3 p-md-4 mb-3 mb-md-4">
                      <h5 className="fw-bold mb-2 mb-md-3 text-secondary fs-6 fs-md-5">
                        <i className="bi bi-receipt me-2"></i>
                        İşlem Detayları
                      </h5>
                      <hr className="my-2 my-md-3" />

                      {xid && (
                        <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center mb-2 mb-md-3 pb-2 pb-md-3 border-bottom gap-2 gap-sm-0">
                          <span className="text-muted small">
                            <i className="bi bi-hash me-1 me-md-2"></i>İşlem
                            Referans
                          </span>
                          <span className="badge bg-success fs-6 px-2 px-md-3 py-1 py-md-2 text-break">
                            {xid}
                          </span>
                        </div>
                      )}

                      {amount && (
                        <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center mb-2 mb-md-3 pb-2 pb-md-3 border-bottom gap-2 gap-sm-0">
                          <span className="text-muted small">
                            <i className="bi bi-cash-coin me-1 me-md-2"></i>
                            Tutar
                          </span>
                          <span className="fw-bold text-success fs-5">
                            {(parseInt(amount) / 100).toFixed(2)}{" "}
                            {currency || "TL"}
                          </span>
                        </div>
                      )}

                      {installment && (
                        <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center mb-2 mb-md-3 pb-2 pb-md-3 border-bottom gap-2 gap-sm-0">
                          <span className="text-muted small">
                            <i className="bi bi-credit-card me-1 me-md-2"></i>
                            Taksit
                          </span>
                          <span className="badge bg-info text-dark fs-6 px-2 px-md-3 py-1 py-md-2">
                            {installment === "00"
                              ? "Tek Çekim"
                              : installment + " Taksit"}
                          </span>
                        </div>
                      )}

                      {authCode && (
                        <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-2 gap-sm-0">
                          <span className="text-muted small">
                            <i className="bi bi-key me-1 me-md-2"></i>Onay Kodu
                          </span>
                          <span className="badge bg-secondary fs-6 px-2 px-md-3 py-1 py-md-2">
                            {authCode}
                          </span>
                        </div>
                      )}
                    </div>
                  </>
                ) : (
                  <>
                    <div className="text-center mb-3 mb-md-4">
                      <div className="mb-3 mb-md-4 animate__animated animate__shakeX">
                        <XCircle
                          size={window.innerWidth < 576 ? 60 : 80}
                          className="text-danger"
                        />
                      </div>
                      <h1 className="display-6 display-md-5 fw-bold text-danger mb-2 mb-md-3">
                        Ödeme Başarısız
                      </h1>
                      <p className="fs-6 fs-md-5 text-muted mb-0 px-2">
                        <i className="bi bi-exclamation-triangle me-1 me-md-2"></i>
                        İşlem tamamlanamadı
                      </p>
                    </div>

                    <div
                      className="alert alert-danger border-0 shadow-sm mb-3 mb-md-4 py-2 py-md-3"
                      role="alert"
                    >
                      <i className="bi bi-x-circle-fill me-2"></i>
                      <span className="d-none d-sm-inline">
                        Ödeme işlemi gerçekleştirilemedi. Lütfen tekrar
                        deneyiniz.
                      </span>
                      <span className="d-inline d-sm-none">
                        Ödeme başarısız. Tekrar deneyiniz.
                      </span>
                    </div>

                    <div className="bg-light rounded-3 p-3 p-md-4 mb-3 mb-md-4 border border-danger border-opacity-25">
                      <h5 className="fw-bold mb-2 mb-md-3 text-danger fs-6 fs-md-5">
                        <i className="bi bi-info-circle me-2"></i>
                        Hata Detayları
                      </h5>
                      <hr className="my-2 my-md-3" />

                      <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center mb-2 mb-md-3 pb-2 pb-md-3 border-bottom gap-2 gap-sm-0">
                        <span className="text-muted small">
                          <i className="bi bi-exclamation-diamond me-1 me-md-2"></i>
                          Hata Kodu
                        </span>
                        <span className="badge bg-danger fs-6 px-2 px-md-3 py-1 py-md-2">
                          {respCode || "N/A"}
                        </span>
                      </div>

                      <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start gap-2">
                        <span className="text-muted small text-nowrap">
                          <i className="bi bi-chat-left-text me-1 me-md-2"></i>
                          Açıklama
                        </span>
                        <span className="text-danger fw-semibold text-start text-sm-end ms-0 ms-sm-3 text-break">
                          {error || respText || "İşlem reddedildi"}
                        </span>
                      </div>
                    </div>

                    <div
                      className="alert alert-warning border-0 shadow-sm py-2 py-md-3"
                      role="alert"
                    >
                      <i className="bi bi-lightbulb me-2"></i>
                      <small className="d-block d-sm-inline">
                        Sorun devam ederse, bankanızla iletişime geçiniz.
                      </small>
                    </div>
                  </>
                )}

                <button
                  onClick={() => navigate("/")}
                  className={`btn ${
                    success ? "btn-success" : "btn-primary"
                  } btn-lg w-100 mt-3 mt-md-4 shadow-sm d-flex align-items-center justify-content-center gap-2 py-2 py-md-3`}
                  style={{ transition: "all 0.3s ease" }}
                >
                  <ArrowLeft size={window.innerWidth < 576 ? 18 : 20} />
                  <span className="fs-6 fs-md-5">Ödeme Sayfasına Dön</span>
                </button>
              </div>
            </div>

            <div className="text-center mt-3 mt-md-4">
              <small className="text-white opacity-75 d-block fs-6">
                <i className="bi bi-shield-lock me-1"></i>
                Güvenli Ödeme Sistemi
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OdemeSonuc;
